<div (click)="openViewRichTextDialog($event)" *ngIf="content; else emptyContent" class="view-rich-text-container">
  <mat-icon>note_add</mat-icon>
  <span>View</span>
</div>
<ng-template #emptyContent>
  {{ defaultContent }}
</ng-template>
